import React from 'react'
import { ChildrenProps } from '../../modules/types'
import ButtonBase, { ButtonType } from './ButtonBase'

function ButtonPrimary(props: ChildrenProps) {
  return (
    <ButtonBase type={ButtonType.Primary} {...props}>{props.children}</ButtonBase>
  )
}

export default ButtonPrimary
